import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderByPipe } from './order-by.pipe';
import { OrderByService } from './order-by.service';

@NgModule({
  declarations: [OrderByPipe],
  exports: [OrderByPipe],
  imports: [
    CommonModule
  ],
  providers: [OrderByService]
})
export class OrderByModule { }
